import {
  DefaultResponse,
  DeliveryPrice,
  Paginate,
  ParamsType,
} from "@/types/global";
import fetcher from "@/lib/fetcher";
import { buildUrlQueryParams } from "@/utils/build-url-query-params";
import {
  Address,
  AddressCreateBody,
  UserAddressResponse,
  UserAddressPayload,
} from "@/types/address";
import {
  AddressDetailsInterface,
  CreateUserAddressBody,
} from "@/types/checkout";
import { UserDetail } from "@/types/user";

export const addressService = {
  getUserAddresses: () => fetcher<UserAddressResponse>("users/users-addresses"),
  addUserAddress: (body: UserAddressPayload) =>
    fetcher.post<DefaultResponse<{ id: number }>>("users/users-addresses", {
      body,
    }),
  deleteUserAddress: (id: number) =>
    fetcher.delete<DefaultResponse<any>>(`users/users-addresses/delete/${id}`),
  // ... existing methods

  getAll: (params?: ParamsType) =>
    fetcher<Paginate<Address>>(
      buildUrlQueryParams("v1/dashboard/user/addresses", params),
    ),
  createUserAddress: (body: AddressDetailsInterface) =>
    fetcher.post<DefaultResponse<{ id: number }>>("users/users-addresses", {
      body,
    }),
  createUserAddressV1: (body: CreateUserAddressBody) =>
    fetcher.post<DefaultResponse<{ id: number }>>("users/users-addresses", {
      body,
    }),

  create: (data: AddressCreateBody) =>
    fetcher.post<DefaultResponse<UserDetail>>("v1/dashboard/user/addresses", {
      body: data,
    }),

  get: (id?: number) =>
    fetcher<DefaultResponse<Address>>(`v1/dashboard/user/addresses/${id}`),
  delete: (id?: number) =>
    fetcher.delete(`v1/dashboard/user/addresses/delete?ids[0]=${id}`),
  update: (id: number | undefined, data: AddressCreateBody) =>
    fetcher.put<DefaultResponse<Address>>(`v1/dashboard/user/addresses/${id}`, {
      body: data,
    }),
  getDeliveryPrices: (params?: ParamsType) =>
    fetcher<Paginate<DeliveryPrice>>(
      buildUrlQueryParams("v1/rest/delivery-prices", params),
    ),
};
